import dayjs from 'dayjs'
import { DateString, DatetimeString } from '@/types/utils'
import { dayOfWeek } from '@/constants/datetime'

const getJpEra = (date: Date) => {
  const day = dayjs(date)
  if (day.isBefore(dayjs('1868/01/25'))) {
    return ''
  } else if (day.isBefore(dayjs('1912/07/30'))) {
    return '明治'
  } else if (day.isBefore(dayjs('1926/12/25'))) {
    return '大正'
  } else if (day.isBefore(dayjs('1989/01/08'))) {
    return '昭和'
  } else if (day.isBefore(dayjs('2019/05/01'))) {
    return '平成'
  } else {
    return '令和'
  }
}

export const formatJpDate = (date: Date) => {
  const options = {
    era: 'long',
    year: 'numeric',
    month: 'narrow',
    day: 'numeric'
  }
  const jpDate = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', options).format(
    date
  )
  return jpDate.match(/^[1-9]/) ? getJpEra(date) + jpDate : jpDate
}

export const getAllDatesOfMonth = (year: number, month: number) => {
  const lastDateOfMonth = dayjs(new Date(year, month - 1, 1))
    .add(1, 'month')
    .subtract(1, 'day')
    .date()

  return [...new Array(lastDateOfMonth)].map((i, j) => j + 1)
}

export const formatDispayDate = (dateString: DateString) => {
  const date = dayjs(dateString)
  return `${date.year()}年${date.month() + 1}月${date.date()}日(${
    dayOfWeek[date.day()]
  })`
}

export const formatDispayYearMonth = (year: number, month: number) => {
  return `${year}年${('0' + String(month)).slice(-2)}月`
}

export const createDatetimeString = (
  year: number,
  month: number,
  day: number,
  hour: number,
  minute: number,
  second = 0
) =>
  dayjs(new Date(year, month, day, hour, minute, second)).format(
    'YYYY-MM-DD HH:mm:ss'
  ) as DatetimeString
